<template>
	<h1>Modifier type de question</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="Difficulty">Type de question</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="Name"
				placeholder="Name"
			/>
		</div>
		<p v-if="status !== ''" class="status">{{ status }}</p>
		<p class="errors">{{ errors }}</p>
		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	data() {
		return {
			form: {
				name: '',
			},
			errors: '',
		}
	},
	methods: {
		submit() {
			authenticatedApiFetch(`/exercise-sheet-types/${this.$route.params.id}/`, { method: 'PUT', body: JSON.stringify(this.form) })
				.then(() => {
					this.$store.dispatch('getExerciseSheetTypes')
					this.$router.push({ name: 'SuperAdminAllExerciseSheetQuestionTypes' })
				})
				.catch((error) => {
					this.errors = error
				})
		},
		getQuestionType() {
			authenticatedApiFetch(`/exercise-sheet-types/${this.$route.params.id}/`, { method: 'GET' })
				.then(res => res.json())
				.then(res => {
					this.form = res
				})
		},
	},
	created() {
		this.getQuestionType()
	},
}
</script>

<style>
</style>
